const API_URL_BASE = process.env.REACT_APP_API_URL_BASE || '/api';

export default API_URL_BASE;
